import { defineComponent as _defineComponent } from 'vue'
import BlogSectionSimpleItem from './BlogSectionSimpleItem.vue';
import { type TextAlign } from '../../../../types';

interface Props {
  items: {
    image?: {
      src?: string | null;
      alt?: string | null;
    } | null;
    title: string;
    link?: string | null;
    tags?: string[] | null;
    contentAlign?: TextAlign | null;
  }[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogSectionSimpleGrid',
  props: {
    items: null
  },
  setup(__props: any) {



return { __sfc: true,BlogSectionSimpleItem }
}

})